import * as React from 'react';
import * as storageKeys from "../constants/storageKeys";
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import { TokenData } from "../components/interfaces/interfaces";
import { LOGGED_IN_USER, TOKENS, TOKEN_BEARER, TOKEN_EXPIRATION } from '../constants/storageKeys';


export interface UserInfo {
    UserId: string;
    IsAdmin: boolean;
}

export interface Token {
    access_token: string,
    expires_in: Date
}

const ADMIN_ROLE: string = "Admin";

class driverinfosecurity {

    static getBearerTokenFromStorage(): string | null {
        try {
            const storedAccessToken = localStorage.getItem(storageKeys.TOKEN_BEARER);

            if (storedAccessToken !== null) return storedAccessToken;
            return null;
        } catch (ex) {
            return null;
        }
    }

    static saveAccessToken(tokenInfo: TokenData) {
        try {
            localStorage.setItem(
                storageKeys.TOKEN_EXPIRATION,
                tokenInfo.expires_in
            );

            localStorage.setItem(
                storageKeys.TOKEN_BEARER,
                tokenInfo.access_token
            );

            return null;
        } catch (error) {
            return null;
        }
    }

    static getTokenFromStorage(): Token | null {
        try {
            let tempAccessToken: any = localStorage.getItem(storageKeys.TOKEN_BEARER);
            const storedAccessToken: string = tempAccessToken != null ? tempAccessToken : null;

            let tempExpiresIn: any = localStorage.getItem(storageKeys.TOKEN_EXPIRATION);
            const storedExpiresIn: string = tempExpiresIn != null ? tempExpiresIn : null;

            if (storedAccessToken !== null && moment(storedExpiresIn) > moment(new Date())) {
                return {
                    access_token: storedAccessToken,
                    expires_in: moment(storedExpiresIn).toDate()
                };
            }
            return null;
        } catch (ex) {
            console.log("Errror null token " + ex);
            return null;
        }
    }

    static hasValidToken(): boolean {
        let token: Token | null = this.getTokenFromStorage();

        if (token !== null) {
            if (moment(token.expires_in) > moment(new Date)) {
                return true;
            }
            else
                console.log("Bad date");
        }

        return false;
    }

    static logout(): boolean {
        localStorage.removeItem(LOGGED_IN_USER);
        localStorage.removeItem(TOKENS);
        localStorage.removeItem(TOKEN_BEARER);
        localStorage.removeItem(TOKEN_EXPIRATION);
        console.log("Delete all storage");
        return true;
    }

    static isAdmin(): boolean {

        if (this.hasValidToken()) {
            const token = this.getBearerTokenFromStorage();
            if (token !== null) {
                const userInfo = this.parseJwt(token.toString());
                if (userInfo !== null)
                    return userInfo.IsAdmin;
            }
        }

        return false;
    }

    static parseJwt(token: string) {

        const UserIdClaim: string =
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";
        const RoleClaim: string =
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";


        try {
            const parsedToken: any = jwtDecode(token);

            const user: UserInfo = {
                IsAdmin: parsedToken[RoleClaim] === ADMIN_ROLE,
                UserId: parsedToken[UserIdClaim]
            };

            return user;
        } catch (e) {
            return null;
        }
    }
}

export default driverinfosecurity;
